import React from "react";
import { Row, Col, Badge } from "reactstrap";
import { Link } from "react-router-dom";
import { beddowsToDecimal } from "../utils/lisk/utils/lisk/beddowsToDecimal";
import { ExchangeLogo } from "../utils/logos/ExchangeLogo";

const avatarStyleSignup = {
  width: "50px",
  borderRadius: "50px",
  marginRight: "10px",
};

interface Props {
  address: string;
  tag: string;
  balance: number;
  isExchange?: boolean;
  isLiskHQ?: boolean;
  isScam?: boolean;
  identifier?: string;
}

export const KnownAddressElement: React.FC<Props> = ({
  address,
  tag,
  balance,
  isExchange,
  isLiskHQ,
  isScam,
  identifier = "",
}) => {
  return (
    <tr>
      <td>
        <Row>
          <Col className="my-auto text-center" xs={3} lg={1}>
            <Link to={`/account/${address}`}>
              {ExchangeLogo({
                identifier: identifier,
                style: avatarStyleSignup,
                address,
              })}
            </Link>
          </Col>
          <Col xs={9} lg={11}>
            <div className="">
              <p className="title">{tag}</p>
              <p className="text-muted">
                <Link to={`/account/${address}`}>{address}</Link> -{" "}
                {isExchange ? (
                  <Badge
                    className={"badge-info"}
                    style={{ fontSize: "medium" }}
                  >
                    Exchange
                  </Badge>
                ) : null}
                {isLiskHQ ? (
                  <Badge
                    className={"badge-info"}
                    style={{ fontSize: "medium" }}
                  >
                    Lisk HQ
                  </Badge>
                ) : null}
                {isScam ? (
                  <Badge
                    className={"badge-danger"}
                    style={{ fontSize: "medium" }}
                  >
                    Scam!
                  </Badge>
                ) : null}
                <Badge className={"badge-dark"} style={{ fontSize: "medium" }}>
                  {(+beddowsToDecimal(balance).toFixed(2)).toLocaleString()} LSK
                </Badge>
              </p>
            </div>
          </Col>
        </Row>
      </td>
    </tr>
  );
};
